/**
 * An account the main admin marked *Jazdí aj rozvoz* - `FRONTEND.md` §9.685 and §9.686, owner #25.
 *
 * **The owner**: *"Hlavný admin by nemohol vedieť aj chodiť na rozvoz že nemusí mat druhý účet?"* Decided as a
 * per-employee switch on any role: a marked account appears in the dispatch picker, can be sent out with *Vyraziť*,
 * and its delivery cash shows in *Peňaženky* like a driver's.
 *
 * **Read off the untyped row** because the generated client learns `alsoDrives` only at the next regeneration:
 * `GET /employees`, `GET /auth/me`, `GET /auth/me/profile` and `GET /employees/wallets` answer it since
 * `BACKEND.md` §10A.343. Only an explicit `true` is a mark - a server older than that answers nothing, and nothing
 * is not a yes.
 */
export function alsoDrivesOf(row: unknown): boolean {
  if (typeof row !== 'object' || row === null) return false
  return (row as Record<string, unknown>).alsoDrives === true
}

/**
 * Whether somebody drives: the driver role, or a marked account - the backend's `Drivers.drives`, so a screen asks
 * the question the server answers.
 */
export function drives(systemRole: string | null | undefined, alsoDrives: boolean): boolean {
  return (systemRole ?? '').trim() === 'driver' || alsoDrives
}
